import Vue from 'vue'
import { sync } from 'vuex-router-sync'
import App from './App'
import router from './router'
import store from './store'

sync(store, router) // done. Returns an unsync callback fn

Vue.config.productionTip = false

/* eslint-disable no-new */
const app = new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App)
})

if (!app.$store.getters.searchMode) {
  window.vuejsapp = app
}

export { app, router, store }



// WEBPACK FOOTER //
// ./src/main.js